<script>
    export let worksheets = [];
    import Card from './Card.svelte';
    import PurchasePaddle from './PurchasePaddle.svelte';
    import Button from './Button.svelte';
    import { format_price } from './utils/format_price';
    import ProductIcon from './ProductIcon.svelte';
    import { worksheets_nav_items } from '../routes/worksheets/worksheets_common.js';
    import { format_age_range } from './utils/format_ages';

    export let h_level = 2;
    let className = '';
    export { className as class };
    export let price_only = false;
    export let horizontal = false;
    export let feature = 'worksheet';
    export let show_actions = true;
    export let mark_purchased = true;
    export let icon_class = '';

    function get_age_group_path(min_age, max_age) {
        // Prefer specific age groups (skip the "For All Ages" catch-all)
        const all_groups = worksheets_nav_items || [];
        const groups =
            all_groups.filter(
                (group) => group.min_age != null || group.max_age != null
            ) || [];
        const safe_min = min_age ?? 0;
        const safe_max = max_age ?? 100;

        const match =
            groups.find((group) => {
                const group_min = group.min_age ?? 0;
                const group_max = group.max_age ?? 100;

                return group_max >= safe_min && group_min <= safe_max;
            }) || null;

        // Fall back to the first nav item (typically "For All Ages") if no specific group matches
        const fallback = all_groups[0] || null;
        const path = (match || fallback)?.path || '';

        return `/worksheets${path ? '/' + path : ''}`;
    }
</script>

{#each worksheets.filter((w) => w.listed) as worksheet}
    {@const worksheet_for_icon = mark_purchased
        ? worksheet
        : { ...worksheet, purchased: false }}
    <Card
        p_sm
        href={`/worksheets/${worksheet.slug}`}
        click_event={{ name: `worksheets-card-click-${feature}`, data: { slug: worksheet.slug } }}
        aria_label={worksheet.title}
        class="{className} flex {horizontal
            ? 'flex-row gap-4 items-center'
            : 'flex-col'} relative"
    >
        <ProductIcon
            product={worksheet_for_icon}
            class="mx-auto my-4 pointer-events-none {horizontal
                ? 'max-sm:hidden '
                : ''} {icon_class}"
        />

        <div class="flex-1">
            <svelte:element this={`h${h_level}`} class="link link-el mb-2 font-bold text-xl pointer-events-none">
                {@html worksheet.title}
            </svelte:element>
            {#if (worksheet.min_age || worksheet.max_age) && !horizontal}
                <a
                    href={get_age_group_path(
                        worksheet.min_age,
                        worksheet.max_age
                    )}
                    class="text-sm mb-1 bg-surface-highlight rounded-bl-xl px-2 py-1 -ml-1 w-fit absolute top-0 right-0 text-nowrap"
                >
                    {format_age_range(worksheet.min_age, worksheet.max_age)}
                </a>
            {/if}
            <p class="flex-1">{@html worksheet.lead}</p>
        </div>

        {#if worksheet.price && price_only && !worksheet.purchased}
            <span class="text-lg font-extrabold"
                >{format_price(
                    worksheet.price.price,
                    worksheet.price.currency,
                    'code'
                )}</span
            >
        {:else if show_actions}
            {#if worksheet.price && !worksheet.purchased && !price_only}
                <p class="mt-4">
                    <PurchasePaddle
                        product={worksheet}
                        style="small"
                        cta="Buy Now"
                        cta_free="Get for Free"
                        {feature}
                    />
                </p>
            {:else if !price_only}
                <p class="mt-4 relative">
                    <Button
                        primary
                        outline
                        route={`/worksheets/${worksheet.slug}`}
                    >
                        Download
                    </Button>
                </p>
            {/if}
        {/if}
    </Card>
{/each}
